/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface BillDetailPayee1
 */
export interface BillDetailPayee1 {
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee1
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee1
     */
    'bankCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee1
     */
    'bankName': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee1
     */
    'branchCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee1
     */
    'branchName': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee1
     */
    'accountType': BillDetailPayee1AccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee1
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee1
     */
    'accountHolder': string;
    /**
     * 
     * @type {boolean}
     * @memberof BillDetailPayee1
     */
    'isSaved': boolean;
}

export const BillDetailPayee1AccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    depositAccount: 'DEPOSIT_ACCOUNT',
    otherAccount: 'OTHER_ACCOUNT'
} as const;

export type BillDetailPayee1AccountTypeEnum = typeof BillDetailPayee1AccountTypeEnum[keyof typeof BillDetailPayee1AccountTypeEnum];


